// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1yUlj","inner":"Footer_inner__J7ZUP","nextIcon":"Footer_nextIcon__3ytTX","innerLeft":"Footer_innerLeft__24JDO"};